import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Send } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { AuthShell } from "@/components/AuthShell";
import { Field, GradButton } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

const ALANLAR = [["unvan", "Firma ünvanı *"], ["yetkili", "Yetkili adı soyadı *"], ["email", "E-posta *", "email"], ["telefon", "Telefon *", "tel"],
  ["vergi_dairesi", "Vergi dairesi"], ["vergi_no", "Vergi no / TCKN"], ["il", "İl"], ["ilce", "İlçe"]];

export default function BayiBasvuru() {
  const [f, setF] = useState({ web: "" });
  const [err, setErr] = useState("");
  const [tamam, setTamam] = useState(false);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const gonder = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try { await api.post("/bayi-basvuru", f); setTamam(true); } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  if (tamam) return (
    <AuthShell title="Başvurunuz alındı" desc="İnceleyip onayladığımızda giriş bilgileriniz e-postanıza gelecek.">
      <div className="flex flex-col items-center gap-4 py-4" data-testid="basvuru-tamam"><CheckCircle2 className="w-12 h-12 text-emerald-400" />
        <Link to="/login" className="text-sm text-muted-foreground hover:text-white">Giriş sayfasına dön</Link></div>
    </AuthShell>
  );
  return (
    <AuthShell title="Bayi başvurusu" desc="Bilgilerinizi bırakın; onaydan sonra bayi portalına giriş yapabilirsiniz.">
      <form onSubmit={gonder} className="grid sm:grid-cols-2 gap-3" data-testid="basvuru-form">
        {ALANLAR.map(([k, l, t]) => (
          <Field key={k} label={l} className={k === "unvan" ? "sm:col-span-2" : ""}>
            <Input data-testid={`basvuru-${k}`} type={t || "text"} required={l.endsWith("*")} value={f[k] || ""} onChange={(e) => set(k, e.target.value)} className="bg-white/5" />
          </Field>
        ))}
        <Field label="Adres" className="sm:col-span-2"><Input data-testid="basvuru-adres" value={f.adres || ""} onChange={(e) => set("adres", e.target.value)} className="bg-white/5" /></Field>
        <Field label="Mesajınız" className="sm:col-span-2"><Textarea data-testid="basvuru-mesaj" value={f.mesaj || ""} onChange={(e) => set("mesaj", e.target.value)} className="bg-white/5" maxLength={1000} /></Field>
        <input tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" value={f.web} onChange={(e) => set("web", e.target.value)} name="web" />
        {err && <div data-testid="basvuru-hata" className="sm:col-span-2 text-sm text-red-400">{err}</div>}
        <GradButton type="submit" disabled={busy} data-testid="basvuru-gonder" className="sm:col-span-2 justify-center h-11"><Send className="w-4 h-4" />{busy ? "Gönderiliyor…" : "Başvuruyu gönder"}</GradButton>
        <Link to="/login" className="sm:col-span-2 text-center text-sm text-muted-foreground hover:text-white" data-testid="basvuru-giris">Zaten hesabım var, giriş yap</Link>
      </form>
    </AuthShell>
  );
}
